// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__HM_Rj","content":"LayoutSettings_content__BtGZM"};